"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleResponseV2 = void 0;
var RoleResponseV2;
(function (RoleResponseV2) {
    let RoleCode;
    (function (RoleCode) {
        RoleCode["WORKSPACE_USER"] = "WorkspaceUser";
        RoleCode["WORKSPACE_ADMINISTRATOR"] = "WorkspaceAdministrator";
    })(RoleCode = RoleResponseV2.RoleCode || (RoleResponseV2.RoleCode = {}));
})(RoleResponseV2 || (exports.RoleResponseV2 = RoleResponseV2 = {}));
